import script from "./container.vue?vue&type=script&setup=true&name=containerBox&lang=js"
export * from "./container.vue?vue&type=script&setup=true&name=containerBox&lang=js"

import "./container.vue?vue&type=style&index=0&id=af2229ea&scoped=true&lang=css"
import "./container.vue?vue&type=style&index=1&id=af2229ea&lang=css"

import exportComponent from "D:\\Jawsro\\company\\hujing\\v3\\hujing_pro_h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af2229ea"]])

export default __exports__